import { Card, Empty } from "antd";
import BarList from "./BarList";
import { CATEGORICAL, INK, periodLabel } from "../crmDashboardUtils";

const MAX_ROWS = 6;

const SourceBreakdown = ({ data = [], period }) => {
  const total = data.reduce((s, d) => s + d.count, 0);

  // Top sources by name; the long tail folds into one neutral "Other" row.
  const top = data.slice(0, MAX_ROWS - (data.length > MAX_ROWS ? 1 : 0));
  const rest = data.slice(top.length);
  const rows = top.map((d) => ({
    key: d.name,
    label: d.name,
    value: d.count,
    display: d.count.toLocaleString(),
    secondary: total ? `${Math.round((d.count / total) * 100)}%` : "",
    color: CATEGORICAL[0],
    static: true,
  }));
  if (rest.length) {
    const other = rest.reduce((s, d) => s + d.count, 0);
    rows.push({
      key: "__other",
      label: `Other (${rest.length})`,
      value: other,
      display: other.toLocaleString(),
      secondary: total ? `${Math.round((other / total) * 100)}%` : "",
      color: INK.other,
      static: true,
    });
  }

  return (
    <Card className="crm-card" variant="borderless">
      <div className="crm-card-head">
        <div>
          <div className="crm-card-title">Where leads come from</div>
          <div className="crm-card-sub">
            <b className="crm-card-figure">{total.toLocaleString()}</b> new leads {periodLabel(period)}
          </div>
        </div>
      </div>

      {total === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No new leads in this period" style={{ padding: "32px 0" }} />
      ) : (
        <BarList rows={rows} />
      )}
    </Card>
  );
};

export default SourceBreakdown;
